import { SelectMultiComponent } from '@/common/select-multi/select-multi.component';
import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { AccommodationService } from 'src/app/accommodation/accommodation.service';
import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { AccommodationsDataService } from '../accommodations-data.service';
import { DateRange } from '@/reservation/reservation.model';
import { AccommodationFileProduct, SetAvailabilityAction } from '@/accommodation-file/_models/accommodation-list.model';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
	selector: 'app-accommodations-availability-set',
	templateUrl: './accommodations-availability-set.component.html',
	styleUrls: ['./accommodations-availability-set.component.scss'],
	imports: [
		SelectMultiComponent,
		CommonModule,
		MatMenuModule,
		MatSelectModule,
		CommonModule,
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatAutocompleteModule,
		MatButtonModule,
		MatDialogModule,
		MatCheckboxModule,
	],
	standalone: true,
})
export class AccommodationsAvailabilitySetComponent implements OnInit {
	dialogData = inject(MAT_DIALOG_DATA);

	availabilityType: Array<object> = [
		{ id: 'A', name: 'Allotment' },
		{ id: 'G', name: 'Gwarancja' },
	];
	currency: Array<any> = [];
	roomSlaves: Array<any> = [];
	data = {
		action: null,
		currency: null,
		room: [],
		dateRange: {
			lower: null,
			upper: null,
			bounds: '[]',
		} as DateRange,
		roomSlave: [],
		cost: null,
		availabilityType: null,
		roomSlavesRemove: false,
		comment: null,
	};
	error = {
		dateRange: false,
		currency: false,
		cost: false,
		availabilityType: false,
	};
	product: AccommodationFileProduct = null;

	readonly SetAvailabilityAction = SetAvailabilityAction;

	constructor(
		public dialogRef: MatDialogRef<any>,
		public service: AccommodationService,
		public dataService: AccommodationsDataService,
		public loader: LoaderService,
		private readonly bag: DataBagService,
		private readonly question: QuestionService,
		private readonly infobox: InfoboxService,
	) {}

	ngOnInit(): void {
		this.bag.get('/currency/', (result) => {
			this.currency = result.results;
		});

		this.setupDialogData();
	}

	private dialogClose(): void {
		this.dialogRef.close(true);
	}

	protected roomChanged(): void {
		const roomSlaves = [];
		this.data.room.forEach((room) => {
			room.roomSlaves.forEach((slave) => {
				roomSlaves.push({
					id: slave.id,
					name: slave.roomType.name + ' z ' + room.name,
				});
			});
		});
		this.data.roomSlave = [];
		this.roomSlaves = roomSlaves;
	}

	protected set(): void {
		if (!this.check()) {
			return;
		}
		this.loader.show();
		let setData;
		switch (this.data.action) {
			case SetAvailabilityAction.SET:
				setData = this.data.room.map((room) => {
					return {
						room: room.id,
						currency: this.data.currency,
						date_range: this.data.dateRange,
						cost: this.data.cost,
						availability_type: this.data.availabilityType,
					};
				});
				this.apiSet('/product/room/availability/', setData).then(() => {
					setData = this.data.roomSlave.map((room) => {
						return {
							room_slave: room.id,
							date_range: this.data.dateRange,
						};
					});
					this.apiSet('/product/room_slave/availability/', setData).then(() => {
						this.dialogClose();
					});
				});
				break;
			case SetAvailabilityAction.DELETE:
				if (this.data.roomSlave.length) {
					setData = this.data.roomSlave.map((room) => {
						return {
							roomSlave: room.id,
							dateRange: this.data.dateRange,
							roomNumber: room.roomNumber,
						};
					});
					this.apiSetDel('/product/room_slave/availability/bulk_delete/', setData).then(() => {
						this.dialogClose();
					});
				}

				if (this.data.roomSlavesRemove || this.data.room.length === 0) {
					return;
				}

				setData = this.data.room.map((room) => {
					return {
						room: room.id,
						dateRange: this.data.dateRange,
						roomNumber: room.roomNumber,
					};
				});
				this.apiSetDel('/product/room/availability/bulk_delete/', setData).then(() => {
					this.dialogClose();
				});
				break;
			case SetAvailabilityAction.LOCK_SELL:
				this.data.dateRange = this.setAccommodationHoursToState(this.data.dateRange);
				setData = this.data.room.map((room) => {
					return {
						room: room.id,
						dateRange: this.data.dateRange,
						roomNumber: room.roomNumber,
						state: 'S',
						comment: this.data.comment,
					};
				});
				this.apiSet('/product/room/availability_state/', setData).then(() => {
					this.dialogClose();
				});
				break;
			case SetAvailabilityAction.LOCK_AVAILABILITY:
				this.data.dateRange = this.setAccommodationHoursToState(this.data.dateRange);
				setData = this.data.room.map((room) => {
					return {
						room: room.id,
						dateRange: this.data.dateRange,
						roomNumber: room.roomNumber,
						state: 'L',
						comment: this.data.comment,
					};
				});
				this.apiSet('/product/room/availability_state/', setData).then(() => {
					this.dialogClose();
				});
				break;
			case SetAvailabilityAction.REMOVE_BLOCKADS:
				this.question.ask('Czy jesteś pewien?', 'removeState').subscribe((result) => {
					if (result.dialogId !== 'removeState') {
						return;
					}
					if (!result.result) {
						this.loader.hide();
						return;
					}
					setData = this.data.room.map((room) => {
						return {
							room: room.id,
							dateRange: this.data.dateRange,
							roomNumber: room.roomNumber,
						};
					});
					this.apiSetDel('/product/room/availability_state/bulk_delete/', setData).then(() => {
						this.dialogClose();
					});
				});

				break;
		}
		return;
	}

	private apiSet(url: string, data): Promise<void> {
		this.loader.show();
		for (const key in this.error) {
			this.error[key] = false;
		}
		return new Promise((resolve, reject) => {
			this.bag.post(url, data, (result, error) => {
				this.loader.hide();
				if (result) {
					resolve();
				} else {
					for (const key in error.error) {
						this.error[key] = true;
					}
					reject();
				}
			});
		});
	}

	private apiSetDel(url: string, data): Promise<void> {
		this.loader.show();
		for (const key in this.error) {
			this.error[key] = false;
		}
		return new Promise((resolve, reject) => {
			this.bag.delete(url, data, (result, error) => {
				this.loader.hide();
				if (result) {
					this.dataService.loadAvailabilities();
					resolve();
				} else {
					for (const key in error.error) {
						this.error[key] = true;
					}
					reject();
				}
			});
		});
	}

	private check(): boolean {
		if (this.data.room.length === 0 && this.data.roomSlave.length === 0) {
			this.infobox.error('Brak wybranego pokoju');
			return false;
		}
		if (this.data.dateRange.lower === null || this.data.dateRange.upper === null) {
			this.infobox.error('Brak Zakresu Dat');
			return false;
		}
		if (this.data.action === SetAvailabilityAction.SET && this.data.availabilityType === null) {
			this.infobox.error('Brak Rodzaju dostępności');
			return false;
		}
		if (this.data.action === SetAvailabilityAction.SET && this.data.cost === null) {
			this.infobox.error('Brak Kosztu');
			return false;
		}
		if (this.data.action === SetAvailabilityAction.SET && this.data.currency === null) {
			this.infobox.error('Brak Waluty');
			return false;
		}
		if (
			(this.data.action === SetAvailabilityAction.LOCK_AVAILABILITY ||
				this.data.action === SetAvailabilityAction.LOCK_SELL) &&
			this.data.comment === null
		) {
			this.infobox.error('Brak Komentarza');
			return false;
		}
		return true;
	}

	private setAccommodationHoursToState(dateRange: DateRange): DateRange {
		dateRange.lower += 'T15:00:00Z';
		dateRange.upper += 'T10:00:00Z';
		return dateRange;
	}

	private setupDialogData(): void {
		if (this.dialogData?.product) {
			this.product = {
				...this.dialogData.product,
				rooms: this.dialogData.product.rooms.map((room, index) => ({
					...room,
					name: `${index + 1}. ${room.roomNumber} (${room.roomType.code}) p: ${room.level} w: ${room?.view}`,
				})),
			};
		}

		if (this.dialogData?.action) {
			this.data.action = this.dialogData.action;
		}

		if (this.dialogData?.dateRange) {
			this.data.dateRange = this.dialogData?.dateRange;
		}

		if (this.dialogData?.dateRange) {
			this.data.dateRange = this.dialogData?.dateRange;
		}

		if (this.dialogData?.rooms) {
			// rooms
			this.data.room = this.dialogData?.rooms
				.filter((room) => this.product.rooms.find((r) => r.id === room))
				.map((room) => this.product.rooms.find((r) => r.id === room));
			this.roomChanged();
			// room slaves
			const roomSlaves = this.product.rooms.flatMap((r) => r.roomSlaves);
			this.data.roomSlave = this.dialogData?.rooms
				.filter((room) => !this.product.rooms.find((r) => r.id === room))
				.map((id) => {
					const roomSlave = roomSlaves.find((r) => r.id === id);
					return { ...roomSlave, name: roomSlave.roomType.code };
				});
		}
	}
}
